$( window ).on( "load", function() {
	$( ".benefits__item" ).click( function() {
		$( this ).toggleClass( "benefits-active" );
		$( ".benefits__item" ).not( this ).removeClass( "benefits-active" );
	} );
} );
 